import React from "react";

const SettingsPage = () => {
  return (
    <div className="max-w-[1440px] m-auto pt-24 md:px-6 px-4 md:py-8 py-4">
      <h1 className="text-2xl font-semibold text-[#242424] mb-4">Settings</h1>
      <p className="text-[#595959]">This is a placeholder Settings page.</p>
    </div>
  );
};

export default SettingsPage;

